import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-366649ea")

_pushScopeId("data-v-366649ea")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "统计时间段", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "员工", -1)
const _hoisted_5 = { style: {"float":"right","color":"#909399","font-size":"12px"} }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "搜索", -1)
const _hoisted_7 = {
  class: "flex mar-t-16 mar-b-16",
  style: {"gap":"16px","flex-wrap":"wrap"}
}
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "stat-card-title" }, "录入到期总数", -1)
const _hoisted_10 = { class: "stat-card-value c-red" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "stat-card-title" }, "跟进车辆", -1)
const _hoisted_13 = { class: "stat-card-value" }
const _hoisted_14 = { class: "stat-card" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "stat-card-title" }, "商业险总金额", -1)
const _hoisted_16 = { class: "stat-card-value" }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "stat-card-title" }, "交强险总金额", -1)
const _hoisted_19 = { class: "stat-card-value" }
const _hoisted_20 = { class: "stat-card" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "stat-card-title" }, "意外险总金额", -1)
const _hoisted_22 = { class: "stat-card-value" }
const _hoisted_23 = { class: "flex flexR mar-t-22" }
const _hoisted_24 = { class: "chart-grid" }
const _hoisted_25 = { class: "chart-card" }
const _hoisted_26 = {
  class: "chart-card-title flex alignC",
  style: {"justify-content":"space-between"}
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "保险公司金额占比", -1)
const _hoisted_28 = { class: "flex alignC" }
const _hoisted_29 = {
  class: "chart-card-body",
  style: {"height":"360px","position":"relative"}
}
const _hoisted_30 = {
  ref: "bxgsChartRef",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_31 = {
  key: 0,
  class: "chart-empty-hint"
}
const _hoisted_32 = { class: "chart-card" }
const _hoisted_33 = {
  class: "chart-card-title flex alignC",
  style: {"justify-content":"space-between"}
}
const _hoisted_34 = /*#__PURE__*/_createVNode("span", null, "达成率", -1)
const _hoisted_35 = { class: "flex alignC" }
const _hoisted_36 = {
  class: "chart-card-body",
  style: {"height":"360px","position":"relative"}
}
const _hoisted_37 = {
  ref: "rateChartRef",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_38 = {
  key: 0,
  class: "chart-empty-hint"
}
const _hoisted_39 = { class: "chart-card" }
const _hoisted_40 = {
  class: "chart-card-title flex alignC",
  style: {"justify-content":"space-between"}
}
const _hoisted_41 = /*#__PURE__*/_createVNode("span", null, "业务员业绩占比", -1)
const _hoisted_42 = { class: "flex alignC" }
const _hoisted_43 = {
  class: "chart-card-body",
  style: {"height":"360px","position":"relative"}
}
const _hoisted_44 = {
  ref: "ywyChartRef",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_45 = {
  key: 0,
  class: "chart-empty-hint"
}
const _hoisted_46 = { class: "flex alignC top-button-group" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "统计时间段", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "员工", -1)
const _hoisted_49 = { style: {"float":"right","color":"#909399","font-size":"12px"} }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "搜索", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("span", null, "到店车辆", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "成交车辆", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "流失车辆", -1)
const _hoisted_54 = { class: "flex flexR mar-t-22" }
const _hoisted_55 = {
  key: 1,
  style: {"min-height":"calc(100vh - 200px)"}
}
const _hoisted_56 = {
  key: 2,
  class: "permission-empty"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_empty = _resolveComponent("el-empty")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.hasAnyPermission)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTab = $event)),
          type: "border-card"
        }, {
          default: _withId(() => [
            (_ctx.roleList.performance_details)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: "业绩明细",
                  name: "detail"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.dateRange,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
                        class: "mar-r-16",
                        type: "daterange",
                        "unlink-panels": "",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        onChange: _ctx.getTableData,
                        shortcuts: _ctx.shortcuts
                      }, null, 8, ["modelValue", "onChange", "shortcuts"]),
                      _hoisted_4,
                      _createVNode(_component_el_select, {
                        class: "mar-r-16",
                        style: {"width":"260px"},
                        modelValue: _ctx.admin_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.admin_id = $event)),
                        placeholder: "请选择（可搜索）",
                        clearable: "",
                        filterable: "",
                        onChange: _ctx.getTableData
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.staffList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, {
                              default: _withId(() => [
                                _createVNode("span", null, _toDisplayString(item.name), 1),
                                _createVNode("span", _hoisted_5, _toDisplayString(item.store_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]),
                      _createVNode(_component_el_button, {
                        class: "bg-red",
                        onClick: _ctx.getTableData
                      }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.summary.totalETime || 0), 1)
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.summary.totalGj || 0), 1)
                      ]),
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode("div", _hoisted_16, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.summary.totalSAmount)), 1)
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode("div", _hoisted_19, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.summary.totalJAmount)), 1)
                      ]),
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode("div", _hoisted_22, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.summary.totalYAmount)), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.pagedData,
                        stripe: "",
                        style: {"width":"100%"},
                        class: "table",
                        "header-cell-style": _ctx.headClass
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            label: "日期",
                            align: "center",
                            "min-width": "100"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.date), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "专员",
                            align: "center",
                            "min-width": "80"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.admin_name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "录入到期数",
                            align: "center",
                            "min-width": "100"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.record_count), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "跟进数",
                            align: "center",
                            "min-width": "80"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.gj_count), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "商业险金额",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_sy_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "交强险金额",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_jq_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "意外险金额",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_yw_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "车船税",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_cqs_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "总金额",
                            align: "center",
                            "min-width": "100"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "客户佣金",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_shfbxgs_amount)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "保险公司佣金",
                            align: "center",
                            "min-width": "110"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.total_bxgsfje_amount)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "header-cell-style"]), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode(_component_el_pagination, {
                        onSizeChange: _ctx.handleSizeChange,
                        onCurrentChange: _ctx.handleCurrentChange,
                        "current-page": _ctx.currentPage,
                        "page-sizes": [10, 20, 50],
                        "page-size": _ctx.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _ctx.allData.length
                      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.roleList.performance_chart)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 1,
                  label: "业绩图表",
                  name: "chart"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        _createVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode("div", _hoisted_28, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.chartMonth,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.chartMonth = $event)),
                              type: "month",
                              format: "YYYY-MM",
                              placeholder: "选择月份",
                              size: "small",
                              clearable: false,
                              onChange: _ctx.getChartData,
                              style: {"width":"150px"}
                            }, null, 8, ["modelValue", "onChange"])
                          ])
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, null, 512),
                          (!_ctx.hasChartData)
                            ? (_openBlock(), _createBlock("span", _hoisted_31, "暂无数据"))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_directive_loading, _ctx.chartLoading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode("div", _hoisted_35, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.rateMonth,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.rateMonth = $event)),
                              type: "month",
                              format: "YYYY-MM",
                              placeholder: "选择月份",
                              size: "small",
                              clearable: false,
                              onChange: _ctx.getRateData,
                              style: {"width":"150px"}
                            }, null, 8, ["modelValue", "onChange"])
                          ])
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_36, [
                          _createVNode("div", _hoisted_37, null, 512),
                          (!_ctx.hasRateData)
                            ? (_openBlock(), _createBlock("span", _hoisted_38, "暂无数据"))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_directive_loading, _ctx.rateLoading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_39, [
                        _createVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode("div", _hoisted_42, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.ywyMonth,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ywyMonth = $event)),
                              type: "month",
                              format: "YYYY-MM",
                              placeholder: "选择月份",
                              size: "small",
                              clearable: false,
                              onChange: _ctx.getYwyData,
                              style: {"width":"150px"}
                            }, null, 8, ["modelValue", "onChange"])
                          ])
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_43, [
                          _createVNode("div", _hoisted_44, null, 512),
                          (!_ctx.hasYwyData)
                            ? (_openBlock(), _createBlock("span", _hoisted_45, "暂无数据"))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_directive_loading, _ctx.ywyLoading]
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.roleList.customer_acquisition_data)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 2,
                  label: "获客数据",
                  name: "lead"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.dateRange,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange = $event)),
                        class: "mar-r-16",
                        type: "daterange",
                        "unlink-panels": "",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        onChange: _ctx.getTableData,
                        shortcuts: _ctx.shortcuts
                      }, null, 8, ["modelValue", "onChange", "shortcuts"]),
                      _hoisted_48,
                      _createVNode(_component_el_select, {
                        class: "mar-r-16",
                        style: {"width":"260px"},
                        modelValue: _ctx.admin_id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.admin_id = $event)),
                        placeholder: "请选择（可搜索）",
                        clearable: "",
                        filterable: "",
                        onChange: _ctx.getLeadTableData
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.staffList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, {
                              default: _withId(() => [
                                _createVNode("span", null, _toDisplayString(item.name), 1),
                                _createVNode("span", _hoisted_49, _toDisplayString(item.store_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]),
                      _createVNode(_component_el_button, {
                        class: "bg-red",
                        onClick: _ctx.getLeadTableData
                      }, {
                        default: _withId(() => [
                          _hoisted_50
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createVNode("div", null, [
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.leadPagedData,
                        stripe: "",
                        style: {"width":"100%"},
                        class: "table",
                        "header-cell-style": _ctx.headClass
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            label: "日期",
                            align: "center",
                            "min-width": "100"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.date), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "专员",
                            align: "center",
                            "min-width": "80"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row['admin name']), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "录入车辆",
                            align: "center",
                            "min-width": "100"
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.input_car), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            "min-width": "80"
                          }, {
                            header: _withId(() => [
                              _createVNode(_component_el_tooltip, {
                                content: "接车开单",
                                placement: "top"
                              }, {
                                default: _withId(() => [
                                  _hoisted_51
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.arrive_car), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            "min-width": "80"
                          }, {
                            header: _withId(() => [
                              _createVNode(_component_el_tooltip, {
                                content: "开单后成交",
                                placement: "top"
                              }, {
                                default: _withId(() => [
                                  _hoisted_52
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.bargain_car), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            "min-width": "80"
                          }, {
                            header: _withId(() => [
                              _createVNode(_component_el_tooltip, {
                                content: "开单后未成交",
                                placement: "top"
                              }, {
                                default: _withId(() => [
                                  _hoisted_53
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.lose_car), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "header-cell-style"]), [
                        [_directive_loading, _ctx.leadLoading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_54, [
                      _createVNode(_component_el_pagination, {
                        onSizeChange: _ctx.handleLeadSizeChange,
                        onCurrentChange: _ctx.handleLeadCurrentChange,
                        "current-page": _ctx.leadCurrentPage,
                        "page-sizes": [10, 20, 50],
                        "page-size": _ctx.leadPageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _ctx.leadAllData.length
                      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (!_ctx.permissionLoaded)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_55, null, 512)), [
            [_directive_loading, true]
          ])
        : (_openBlock(), _createBlock("div", _hoisted_56, [
            _createVNode(_component_el_empty, { description: "暂无权限访问，请联系管理员" })
          ]))
  ]))
})